import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=58c4f74b&"
import script from "./Request.vue?vue&type=script&lang=ts&"
export * from "./Request.vue?vue&type=script&lang=ts&"
import style0 from "./Request.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports